import { render, staticRenderFns } from "./EncabezadoComponent.vue?vue&type=template&id=fd1aea6a&"
import script from "./EncabezadoComponent.vue?vue&type=script&lang=js&"
export * from "./EncabezadoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports